import React from 'react';
import { useAuth } from '../context/AuthContext';

// Hospital selector dropdown — shown only to global admins (hospitalId null).
// Per-hospital users are locked to their hospital and never see this.
// Switching the hospital sets the X-Hospital-Id header for all subsequent
// API calls (via ApiUtils.setActiveHospitalId) and triggers a data refetch
// in AppContent (activeHospitalId is a useEffect dependency).
const HospitalSelector = () => {
  const { isGlobalAdmin, hospitals, activeHospitalId, switchHospital } = useAuth();

  if (!isGlobalAdmin) return null;
  if (!hospitals || hospitals.length === 0) return null;

  return (
    <div className="hospital-selector">
      <i className="fas fa-hospital hospital-selector__icon" title="Active hospital"></i>
      <select
        className="form-control hospital-selector__select"
        value={activeHospitalId || ''}
        onChange={async (e) => {
          // switchHospital awaits the dirty-form guard and returns false when
          // the user declines to discard unsaved changes. The <select> is
          // uncontrolled during the change, so snap it back imperatively.
          const switched = await switchHospital(e.target.value || null);
          if (!switched) e.target.value = activeHospitalId || "";
        }}
        title="Switch hospital context"
      >
        <option value="">All Hospitals (read-only)</option>
        {hospitals.filter(h => h.active !== false).map(h => (
          <option key={h.id} value={h.id}>
            {h.name}
          </option>
        ))}
      </select>
    </div>
  );
};

export default HospitalSelector;